import styled from '@emotion/styled';
import {mixinSVGIconLarge} from 'webapp-lib/styling';

export const IconContainer = styled.div`
  width: var(--icon-large-dimension);
  height: var(--icon-large-dimension);

  position: relative;

  svg {
    ${mixinSVGIconLarge}
  }
`;

export const TextContainer = styled.div`
  font-size: var(--font-size-tiny);
  margin-top: var(--gutter-little);
  font-weight: var(--font-weight-thin);
`;

export const StyledNavigationItem = styled.li`
  & > a {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    text-decoration: none;
    width: var(--navigation-bar-width);
    height: var(--header-height);
    justify-content: center;
    align-items: center;
    color: var(--color-core-white);

    &.active {
      outline-style: none;
      background-color: var(--color-state-active);
    }

    :focus {
      border: var(--focus-border-width) solid var(--color-core-keyboardfocus);
      box-shadow: none;
    }
  }
`;

export const NotificationIndicator = styled.div`
  width: 12px;
  height: 12px;
  background-color: var(--color-notification-important);
  border-radius: 50%;
  position: absolute;
  left: var(--notification-indicator-offset);
`;
